import { Component, inject, Input } from '@angular/core';
import { WhiteLabelConfig } from 'voxr-shared';
import { AppService, ResellerInfo, SSO_REDIRECT_PARAM } from '../../../services/app.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-brand-loading',
  standalone: true,
  imports: [],
  templateUrl: './brand-loading.component.html'
})
export class BrandLoadingComponent {
  private app = inject(AppService);
  private route = inject(ActivatedRoute);

  brand?: ResellerInfo;
  icon!: string;

  async ngOnInit() {
    const ssoRedirect = this.route.snapshot.queryParams[SSO_REDIRECT_PARAM];
    this.brand = ssoRedirect ? await this.app.getResellerByOrigin(new URL(ssoRedirect).origin) : await this.app.reseller$;
    this.icon = this.brand?.ui?.['logoUrl'] || '/assets/images/logo/voxr-icon.png';
  }

}
